export default __webpack_public_path__ + "static/light-node-d298e490eccc994d6987a66721388529.png";